<template>
  <div>
    <b-toast
      id="my-toast"
      toaster="b-toaster-top-center"
      :visible="getShowAlertError"
      variant="danger"
      no-auto-hide
      solid
    >
      <div class="header-toast d-flex flex-grow-1 align-items-baseline">
        <div class="title-message-container">
          <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
          <strong class="mr-auto">{{ getTitleAlertError }}</strong>
        </div>
        <div class="close" @click="close">×</div>
      </div>
      {{ getMessageAlertError }}
    </b-toast>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";

export default {
  name: "ErrorToast",
  computed: {
    ...mapGetters({
      getShowAlertError: "getShowAlertError",
      getTitleAlertError: "getTitleAlertError",
      getMessageAlertError: "getMessageAlertError"
    })
  },
  methods: {
    close() {
      store.commit("setShowAlertError", {
        value: false
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header-toast {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: $gap-sm-2;

  .title-message-container {
    flex: 1;
    height: inherit;
    display: flex;
    align-items: center;
  }

  .close {
    flex-basis: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>